module.exports = __webpack_public_path__ + "static/media/banni-clip.5f277fd3.mp3";